import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { SupabaseService } from '../../services/supabase.service';
import { AuthService } from '../../services/auth/auth.service';
import { TopicApi } from '../../data/topic/topic.api';
import { InitializeService } from '../../services/initialize.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private auth = inject(AuthService);
  private topicApi = inject(TopicApi);
  private initializeService = inject(InitializeService);

  form: FormGroup | undefined;
  loginError = false;

  constructor(private fb: FormBuilder,
              private router: Router,
              private supabase: SupabaseService) {
    (window as any)['loginComponent'] = this;
  }

  testError() {
    const testObj: any = {};
    testObj.blob();
    console.log(testObj.blob.dobbo);
  }

  ngOnInit() {
    this.form = this.fb.group({
      email: ['', Validators.email],
      password: ['', Validators.required]
    });

    if (!environment.production) {
      this.form.patchValue({
        email: 'dev2@rene.tk',
        password: '12345678'
      })
    }
  }

  async login() {
    if (this.form && this.form.valid) {
      const formValue = this.form?.value;
      try {
        // const userCredential = await signInWithEmailAndPassword(
        //   this.auth,
        //   formValue.email,
        //   formValue.password
        // );

        const authTokenResponse = await this.auth.signIn(
          formValue.email,
          formValue.password
        );
        console.log('loggedIn', authTokenResponse);
        await this.initializeService.initialize();
        this.router.navigateByUrl('today')
      } catch (err) {
        console.log(err);
        this.loginError = true;
      }
    }
  }
}
